import { MACRO_KEY } from "../../../defaults";

export const MACRO_WITH_TEMPLATES = [
  MACRO_KEY.ANNOUNCEMENTS,
  MACRO_KEY.BUTTON,
  MACRO_KEY.BUTTON_INLINE,
  MACRO_KEY.CARDS,
  MACRO_KEY.COUNTDOWN,
  MACRO_KEY.PANEL_SIMPLE,
  MACRO_KEY.IMAGE_SLIDER,
  MACRO_KEY.ADVANCED_TABS_GROUP,
  MACRO_KEY.TOOLTIPS_AND_FOOTNOTES,
  MACRO_KEY.PANEL_ADVANCED,
  MACRO_KEY.NEWS,
  MACRO_KEY.PAGES,
  MACRO_KEY.SPACES,
  MACRO_KEY.PEOPLE,
  MACRO_KEY.RECENTLY_ACTIVE,
  MACRO_KEY.UPCOMING_BIRTHDAYS,
  MACRO_KEY.NEW_STARTERS,
  MACRO_KEY.WORK_ANNIVERSARY,
];

export const MACRO_WITH_COLOR_PALETTE = [
  MACRO_KEY.CARDS,
  MACRO_KEY.ANNOUNCEMENTS,
  MACRO_KEY.COUNTDOWN,
  MACRO_KEY.PANEL_SIMPLE,
  MACRO_KEY.BUTTON,
];

export const TEMPLATES_CUSTOM_WIDTH = [MACRO_KEY.CARDS];
